export default __webpack_public_path__ + "static/media/delete.786df027.svg";